import React, { useEffect, useState } from 'react';

interface EllipsisMiddleTextProps {
  label: string;
  maxLength?: number;
}

const EllipsisMiddleText: React.FC<EllipsisMiddleTextProps> = ({
                                                                 label,
                                                                 maxLength = 20,
                                                               }) => {
  const [hovered, setHovered] = useState(false);
  const [cycleIndex, setCycleIndex] = useState(0);

  const getEllipsisText = (text: string) => {
    if (text.length <= maxLength) return text;
    const partLength = Math.floor((maxLength - 3) / 2);
    return text.slice(0, partLength) + '...' + text.slice(-partLength);
  };


  return (
    <span
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`cursor-pointer w-[${maxLength}ch] whitespace-nowrap overflow-hidden`}
    >
      {hovered ? label : getEllipsisText(label)}
    </span>
  );
};

export default EllipsisMiddleText;